import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {
	return {
		videoRoot: {
			borderRadius              : "1rem",
			height                    : "80dvh",
			border                    : `0.5px solid ${ theme.other.colors.border.primary }`,
			aspectRatio               : "9/16",
			background                : "rgba(0,0,0,0.1)",
			scrollMarginInline        : "1rem",
			[rooterMediaQuery.mobile] : {
				borderRadius : "0",
				border       : "none",
				width        : "100vw",
				height       : "100dvh"
			}
		},
		reelThumbnail: {
			borderRadius : "1rem",
			aspectRatio  : "9/16",
			objectFit    : "cover",
			width        : "100%",

			[rooterMediaQuery.mobile]: {
				aspectRatio  : "9/16",
				height       : "100dvh",
				borderRadius : "0"
			}
		},

		tickIcon: {
			width: "5rem"
		},
		drawerContent: {
			background : theme.other.colors.dialog.primary,
			height     : "fit-content !important"
		},
		drawerWrapper: {
			display        : "flex",
			flexDirection  : "column",
			justifyContent : "center",
			alignItems     : "center",
			margin         : "3rem"
		}
	};
} );
